import { EduResourcesTab } from "../types/edu-resources";

export const TAB_CONFIG = {
  [EduResourcesTab.Folder]: {
    label: "Folders",
    value: EduResourcesTab.Folder,
  },
  [EduResourcesTab.Resources]: {
    label: "Resources",
    value: EduResourcesTab.Resources,
  },
  [EduResourcesTab.AutoSend]: {
    label: "Auto-Send",
    value: EduResourcesTab.AutoSend,
  },
} as const;

export const DEFAULT_TAB = EduResourcesTab.Folder;

export const CURRENT_WEEK_TAB_PARAM = "currentWeek";
export const RECENTLY_SENT_TAB_PARAM = "recently-sent";

export const GA_SCHEDULE_TAB_PARAM = "ga-schedule";
export const NON_GA_RESOURCES_TAB_PARAM = "non-ga-resources";

// Default tab for the client-facing educational resources page.
export const DEFAULT_CLIENT_TAB_PARAM = GA_SCHEDULE_TAB_PARAM;
